import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";

import Button from "../../components/button";
import { SendRounded, CheckRounded } from "@material-ui/icons";

import { baseColor2, logoColor1, logoColor2 } from "../../styles/color";

const LoginButton = ({ text, isSending, isSent, isValid, helpText, onClick }) => {
  if (isSent) {
    return (
      <>
        <Button
          type="submit"
          text="Magic link sent"
          icon={<CheckRounded />}
          bgColor={logoColor2}
          color={baseColor2}
          fullWidth
          disabled
          overrideDisabledStyles
          onClick={onClick}
        />
        <p style={{ margin: 0 }}>{helpText}</p>
      </>
    );
  } else if (isSending) {
    const sendingStyles = css`
      animation: rotation 1s infinite ease-in-out;

      @keyframes rotation {
        from {
          transform: rotate(0deg) translate(-1px, -1px);
        }
        25% {
          transform: rotate(-2deg) translate(-1px, 1px);
        }
        50% {
          transform: rotate(0deg) translate(1px, 0px);
        }
        75% {
          transform: rotate(2deg) translate(2px, 1px);
        }
        to {
          transform: rotate(0deg) translate(-1px, -1px);
        }
      }
    `;

    return (
      <Button
        type="submit"
        text="Sending magic link"
        icon={<SendRounded css={sendingStyles} />}
        bgColor={logoColor1}
        color={baseColor2}
        fullWidth
        disabled
        overrideDisabledStyles
        onClick={onClick}
      />
    );
  } else {
    // Default button, no status to display
    return (
      <Button
        type="submit"
        text={text}
        bgColor={logoColor2}
        color={baseColor2}
        fullWidth
        disabled={!isValid}
        onClick={onClick}
      />
    );
  }
};

LoginButton.defaultProps = {
  text: "Log in",
  isSending: false,
  isSent: false,
  isValid: true,
  helpText:
    "Check your email — we sent you a link that will log you in without a password.",
};

LoginButton.propTypes = {
  text: PropTypes.string,
  isSending: PropTypes.bool,
  isSent: PropTypes.bool,
  isValid: PropTypes.bool,
  helpText: PropTypes.string,
  onClick: PropTypes.func,
};

export default LoginButton;
